export default "__VITE_ASSET__c21b89f3__"